import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import MaskedInput from "react-text-mask"
import createNumberMask from "text-mask-addons/dist/createNumberMask"
import accounting from "accounting"

export default class Payments extends React.Component {
  state = {
    action: 'show',
    descriptionField: '',
    amountOwedField: null,
    amountPaidField: null,
  }

  componentWillMount() {
    const { description, amount_owed, amount_paid } = this.props.payment
    this.setState({
      descriptionField: description,
      amountOwedField: amount_owed ? accounting.formatMoney(amount_owed) : null,
      amountPaidField: amount_paid ? accounting.formatMoney(amount_paid) : null,
    })
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleSave() {
    const { descriptionField, amountOwedField, amountPaidField } = this.state
    const { id } = this.props.payment
    this.setState({ action: 'show' })
    this.props.updatePayment({
      id,
      amount_owed: amountOwedField ? accounting.unformat(amountOwedField) : null,
      amount_paid: amountPaidField ? accounting.unformat(amountPaidField) : null,
      description: descriptionField
    })
  }

  handleDelete() {
    const { id } = this.props.payment
    const deletePayment = confirm('Are you sure you want to delete this payment?')

    if(deletePayment) {
      this.props.deletePayment(id)
    }
  }

  render () {
    const { id, due_date, paid_at, amount_owed, amount_paid, description, balance } = this.props.payment
    const { descriptionField, amountOwedField, amountPaidField } = this.state

    return (
      <tr>
        <td style={{ verticalAlign: 'middle' }}>{due_date ? moment(due_date).format('M/D/YYYY') : null}</td>
        <td style={{ verticalAlign: 'middle' }}>{paid_at ? moment(paid_at).format('M/D/YYYY') : null}</td>
        <td style={{ verticalAlign: 'middle' }}>
          {
            this.state.action == 'show' ? (
              description
            ) : (
              <input
                style={{ width: 80 }}
                name="descriptionField"
                value={descriptionField}
                onChange={(event) => this.handleChange(event)} />
            )
          }
        </td>
        <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
          {
            this.state.action == 'show' ? (
              amount_owed ? accounting.formatMoney(amount_owed) : null
            ) : (
              <MaskedInput
                mask={createNumberMask({ allowDecimal: true })}
                style={{ width: 80 }}
                name="amountOwedField"
                value={amountOwedField}
                onChange={(event) => this.handleChange(event)} />
            )
          }
        </td>
        <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
          {
            this.state.action == 'show' ? (
              amount_paid ? accounting.formatMoney(amount_paid) : null
            ) : (
              <MaskedInput
                mask={createNumberMask({ allowDecimal: true })}
                style={{ width: 80 }}
                name="amountPaidField"
                value={amountPaidField}
                onChange={(event) => this.handleChange(event)} />
            )
          }
        </td>
        <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>{accounting.formatMoney(balance)}</td>
        <td>
          {
            this.state.action == 'show' ? (
              <div>
                <button
                  className="btn btn-sm btn-link text-danger"
                  onClick={() => this.handleDelete()}><i className="fa fa-trash" /></button>
                <button
                  className="btn btn-sm btn-link"
                  onClick={() => this.setState({ action: 'edit' })}><i className="fa fa-edit" /></button>
              </div>
            ) : (
              <button
                className="btn btn-sm btn-block btn-link"
                onClick={() => this.handleSave()}><i className="fa fa-save" /></button>
            )
          }
        </td>
      </tr>
    )
  }
}
